import { Fancybox } from "@fancyapps/ui";
import Faqs from "../../../frontend/blocks/faqs/faqs.js";
import HeaderScroll from "./components/HeaderScroll.js";
import Carousel from "./components/Carousel.js";
import MobileMenu from "./components/MobileMenu.js";
import Toggle from "./components/Toggle.js";
import FooterToggle from "./components/FooterToggle.js";
import Tabs from "./components/Tabs.js";
import GformUpload from "./components/GformUpload.js";
import SmoothScroll from "./components/SmoothScroll.js";
import ArchiveHero from "../../../frontend/blocks/archive-hero/archive-hero.js";
import MedicationTabs from "../../../frontend/blocks/medication-flow-chart/medication-flow-chart.js";
import NumberCounter from "./components/NumberCounter.js";
import FullWidthImageSlider from "../../../frontend/blocks/full-width-image-video/full-width-image-video";
import TestimonialSlider from "../../../frontend/blocks/testimonial-slider/testimonial-slider.js";
import CliniciansSlider from "../../../frontend/blocks/clinicians/clinicians.js";
import MegaMenu from "./components/MegaMenu.js";
import HeaderSearch from "./components/HeaderSearch.js";
import LiveSearch from "./components/LiveSearch.js";
import PieChart from "../../../frontend/blocks/pie-chart/pie-chart.js";
import BarChart from "../../../frontend/blocks/bar-chart/bar-chart.js";
import BookingModal from "./components/BookingModal.js";

MegaMenu();

HeaderSearch();

{
    const numberCounter = document.querySelector(".js-count-up");
    if (typeof numberCounter != "undefined" && numberCounter != null) {
        NumberCounter();
    }
}

{
    const medicationTabs = document.querySelector(".medication-tabs");

    if (typeof medicationTabs != "undefined" && medicationTabs) {
        MedicationTabs();
    }
}

{
    const archiveHero = document.querySelector(".archive-hero__nav-wrap");

    if (typeof archiveHero != "undefined" && archiveHero) {
        ArchiveHero();
    }
}

{
    const cliniciansSlider = document.querySelector(".clinicians");

    if (typeof cliniciansSlider != "undefined" && cliniciansSlider) {
        CliniciansSlider();
    }
}

{
    const slider = document.querySelector(".carousel");

    if (typeof slider != "undefined" && slider) {
        Carousel();
    }
}

{
    const header = document.querySelector(".header");

    if (typeof header != "undefined" && header) {
        HeaderScroll();
    }
}

{
    const faqs = document.querySelector("[data-question]");

    if (typeof faqs != "undefined" && faqs) {
        Faqs();
    }
}

{
    const mobile_menu = document.querySelector(".mobile-menu");

    if (typeof mobile_menu != "undefined" && mobile_menu) {
        MobileMenu();
    }
}

{
    const toggle_element = document.querySelector("[data-toggle]");

    if (typeof toggle_element != "undefined" && toggle_element) {
        Toggle();
    }
}

{
    const footer_toggle = document.querySelector("[data-footer-toggle]");

    if (typeof footer_toggle != "undefined" && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector("[data-tabs]");

    if (typeof tabs != "undefined" && tabs != null) {
        Tabs();
    }
}

{
    if (typeof gform != "undefined" && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector("[data-smooth-scroll]");

    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const fullWidthImageSlider = document.querySelector(
        ".full-width-image-video__images--slider"
    );

    if (
        typeof fullWidthImageSlider != "undefined" &&
        fullWidthImageSlider != null
    ) {
        FullWidthImageSlider(fullWidthImageSlider);
    }
}

{
    const testimonialSlider = document.querySelector(
        "[data-testimonial-slider]"
    );
    if (typeof testimonialSlider != "undefined" && testimonialSlider != null) {
        TestimonialSlider(testimonialSlider);
    }
}


    document.addEventListener('DOMContentLoaded', function () {

        const search = document.querySelector(".knowledge-base-search__input");

        if(typeof search != "undefined" && search != null) {
            LiveSearch();
        }
    }
);

{
    const pieChart = document.querySelector(".pie-chart");
    if (typeof pieChart != "undefined" && pieChart != null) {
        PieChart();
    }
}

{
    const barChart = document.querySelector(".bar-chart");
    if (typeof barChart != "undefined" && barChart != null) {
        BarChart();
    }
}

{
    const bookingModal = document.querySelector('.js-book-assessment');
    if (bookingModal) {
        BookingModal();
    }
}